module.exports = __webpack_public_path__ + "static/img/order-map-marker-point.372f97e1.svg";